import { ValueOf } from '@twiliointernal/e2-commons-shared-definitions';

export enum LegacySupportPaths {
  overview = '/console/support',
  create = '/console/support/tickets/create',
  history = '/console/support/tickets',
  supportPlans = '/console/support/plans',
  /**
   * Fake path that allows useOscRedirect to open OSC in the same tab
   * when a user is logging in from OSC. Temporary workaround until
   * deeplinking functionality in Console Navigation Backend is updated
   * to support 'help' subdomain
   */
  login = '/console/support/login',
  loginToSubmit = '/console/support/login-submit',
}

export enum KnowledgeBaseUrlKey {
  article = 'article',
  category = 'category',
  section = 'section',
  articleAttachments = 'articleAttachments',
}

// WISE OWL UTIL
/**
 * Partial TS type duplicate from @reduxjs/toolkit/query/react
 */
export interface FetchArgs {
  url: string;
  params?: Record<string, any>;
  method: string;
  headers?:
    | Headers
    | string[][]
    | Record<string, string | undefined>
    | undefined;
  body?: any;
}

export interface SetFetchArgsParams {
  fetchArgs: FetchArgs;
  requestService: RequestServiceType;
  isLoggedIn: boolean;
  csrf?: string;
  stargateUngatedUserId?: string;
}

export interface SetWiseOwlBaseUrlParams {
  fetchArgs: FetchArgs;
  isLoggedIn: boolean;
  stargateUngatedUserId?: string;
}

export interface SetHelpCenterUrlParams {
  fetchArgs: FetchArgs;
}

export const RequestService = {
  helpCenter: 'helpCenter',
  wiseOwl: 'wiseOwl',
};
export type RequestServiceType = ValueOf<typeof RequestService>;
